import { IOffering, IOfferingBase, IOfferingDetail, IOfferingDetailItem } from 'app/models';

export interface IOfferingsState {
    companyId: number | null;

    offerings: IOfferingBase[];
    offeringsLoading: boolean;

    selectedOfferingId: number | null;
    selectedOffering: IOffering | null;
    selectedOfferingLoading: boolean;

    saving: boolean;
    deleting: boolean;

    dirty: boolean;

    error: string | null;
}

export const initOfferingState: IOfferingsState = {
    companyId: null,

    offerings: [],
    offeringsLoading: false,

    selectedOfferingId: null,
    selectedOffering: null,
    selectedOfferingLoading: false,

    saving: false,
    deleting: false,

    dirty: false,

    error: null,
};

let nextClientId = -1;

export function newClientId(): number {
    return nextClientId--;
}

export function getDetailTypeName(detailTypeId: number): string {
    switch (detailTypeId) {
        case 1:
            return 'Team Info';
        case 2:
            return 'Target Prospects';
        case 3:
            return 'Qualifying Questions';
        case 4:
            return 'Testimonials';
        default:
            return 'Unknown';
    }
}

export function resequenceItems(items: IOfferingDetailItem[]): IOfferingDetailItem[] {
    return items.map((item, index) => ({
        ...item,
        sortOrder: index + 1,
    }));
}

export function resequenceDetails(details: IOfferingDetail[]): IOfferingDetail[] {
    return details.map((detail, index) => ({
        ...detail,
        sortOrder: index + 1,
        items: resequenceItems(detail.items),
    }));
}

export function moveItem<T>(items: T[], fromIndex: number, toIndex: number): T[] {
    const clone = [...items];
    const [moved] = clone.splice(fromIndex, 1);
    clone.splice(toIndex, 0, moved);
    return clone;
}

export function upsertOfferingSummary(offerings: IOfferingBase[], offering: IOffering): IOfferingBase[] {
    const summary: IOfferingBase = {
        id: offering.id,
        companyId: offering.companyId,
        name: offering.name,
        description: offering.description,
        rateIntro: offering.rateIntro,
        rateCloseMin: offering.rateCloseMin,
        rateCloseMax: offering.rateCloseMax,
        isActive: offering.isActive,
        sortOrder: offering.sortOrder,
    };

    const existingIndex = offerings.findIndex((x) => x.id === offering.id);

    if (existingIndex === -1) {
        return [...offerings, summary].sort((a, b) => a.sortOrder - b.sortOrder || a.id - b.id);
    }

    const clone = [...offerings];
    clone[existingIndex] = summary;
    return clone.sort((a, b) => a.sortOrder - b.sortOrder || a.id - b.id);
}
